var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CURRENCY, { SYMBOL_POSITION, DEFAULT_SEPARATOR_PATTERN, } from './currencyConfig';
import { isCurrencyCode, isCountryCode } from '../utils';
import { DEFAULT_NOTCHES } from './notchConfig';
import { getCountryConfig } from './countryConfig';
export { DEFAULT_NOTCHES } from './notchConfig';
export { CURRENCY as CURRENCY_CONFIG };
export { SYMBOL_POSITION, DEFAULT_SEPARATOR_PATTERN };
export { getCountryConfig };
export function getCurrencyConfig(code, language) {
    if (isCurrencyCode(code)) {
        return CURRENCY[String(code).toUpperCase()];
    }
    else {
        var countryConf = getCountryConfig(code, language);
        var defaultCurrencyConfig = countryConf &&
            countryConf.defaultCurrency &&
            CURRENCY[countryConf.defaultCurrency];
        if (defaultCurrencyConfig) {
            return __assign(__assign({}, defaultCurrencyConfig), countryConf.currencies[countryConf.defaultCurrency]);
        }
        else {
            return CURRENCY.default;
        }
    }
}
export function getCurrencySymbol(code) {
    var conf = getCurrencyConfig(code);
    return (conf && conf.symbol) || '';
}
export function getCurrencySymbolPosition(code) {
    var conf = getCurrencyConfig(code);
    return conf && typeof conf.symbolPosition !== 'undefined'
        ? conf.symbolPosition
        : SYMBOL_POSITION.FRONT;
}
export function getCurrencySpaceBetweenSymbol(code) {
    var conf = getCurrencyConfig(code);
    return (conf && conf.spaceBetweenSymbol) || false;
}
export function getNotches(country, language) {
    if (!isCountryCode(country)) {
        return DEFAULT_NOTCHES;
    }
    if (language) {
        return getCountryConfig(country, language).notches;
    }
    else {
        return getCountryConfig(country).notches;
    }
}
export function getServerNumberConvertRatio(country, currencyId) {
    if (country) {
        var countryConf = getCountryConfig(country);
        var currencyConf = countryConf &&
            countryConf.currencies[currencyId || countryConf.defaultCurrency];
        if (currencyConf && currencyConf.convertRate) {
            return currencyConf.convertRate;
        }
    }
    return 100000;
}
export function getConfigByCountry(country, language) {
    return {
        getCountryConfig: function (countryCode, languageCode) {
            return getCountryConfig(countryCode || country, languageCode || language);
        },
        getServerNumberConvertRatio: getServerNumberConvertRatio,
        getNotches: function (countryCode, languageCode) {
            return getNotches(countryCode || country, languageCode || language);
        },
        getCurrencySymbol: function (countryCode) {
            return getCurrencySymbol(countryCode || country);
        },
        DEFAULT_NOTCHES: DEFAULT_NOTCHES,
        getCurrencyConfig: function (countryCode) {
            return getCurrencyConfig(countryCode || country, language);
        },
    };
}
